<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return [
          'email',
          'number',
          'password',
          'search',
          'tel',
          'text',
          'url',
        ].includes(value)
      },
    },
    rules: { type: String, default: '' },
    label: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<template>
  <BaseValidationProvider
    v-slot="{ errors }"
    :rules="rules"
    :label="label"
    :label-for="$attrs.id"
  >
    <input
      v-bind="$attrs"
      :class="[
        'input',
        {
          'input-error': errors.length,
          'cursor-not-allowed opacity-50': disabled,
        },
      ]"
      :type="type"
      :disabled="disabled"
      v-on="$listeners"
      @input="$emit('update', $event.target.value)"
    />
  </BaseValidationProvider>
</template>
